export default __webpack_public_path__ + "static/media/phoneHero.3851da4d.png";